import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'audiences/audiencelead';
const wizardName = 'Blacklist';
const wizardAction = 'addToBlacklist';
const wizardObject = 'Lead';

const Blacklist = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const [drawable, setDrawable] = useState(true);

    // DATA PROVIDER
    const {
        errorMessage,
        errors,
        saving,
        doAction,
        success
    } = useDataProvider(dataProviderName, false);

    const modelName = existingModules.modelName;

    let detailConfig = {
        "tabs": [
            {
                "name": "confirm",
                "fieldsets": [
                    {
                        "name": "confirm",
                        "fields": {
                            "title": {
                                "type": "sectionmessageblock",
                                "title": "black_list_waring",
                                "paragraph": "black_list_waring_paragraph",
                                "icon": "faTriangleExclamation",
                                "className": "col-12 warning",
                            },
                            "confirm": {
                                "type": "select",
                                "className": "col-12",
                                "label": t("Confermi di voler mettere in blacklist le lead selezionate?"),
                                "options": [{label: "Si", value: "true"}, {label: "Annulla", value: "false"}]
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid)
                } catch (e) {}
            })()
        }
    }, [success, params])

    const handleSave = async (data) => {
        doAction && await doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    "confirm": "true",
                    "ids": params?.filters?.items
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Insert a set of leads in black list')}
                    />
                }
                {...params}
            />
    )
}

export default Blacklist;